import { Icon, IconProps } from '@mui/material';
import React from 'react';

export const useCreateCustomIcon = (icon: string, props: IconProps) => {
  const [cursorStyle, setCursorStyle] = React.useState<'pointer' | 'default'>('pointer');

  const enableCursorPointer = () => {
    setCursorStyle('pointer');
  };

  const enableCursorDefault = () => {
    setCursorStyle('default');
  };

  /** Note: use 'sx' for <Icon> & 'style' for <img> */

  /** ATTENTION!!!!!
   * If you want to change the size of your icon use
   * style={{
   *   width: 1rem,
   *   height: 1rem
   * }} */

  return (
    <Icon
      sx={{
        cursor: cursorStyle,
        width: 'fit-content',
        height: 'fit-content',
        fontSize: 'inherit',
        ...props.sx,
      }}
      style={{ cursor: cursorStyle }}
      className={props.className}
      onMouseEnter={enableCursorPointer}
      onMouseLeave={enableCursorPointer}
      onClick={enableCursorDefault}
    >
      <img
        alt='customIcon'
        src={icon}
        style={{
          verticalAlign: 'middle',
          ...props.style,
        }}
        onClick={props.onClick}
      />
    </Icon>
  );
};